<div class="modal-header">
    <div class="col-md-4">Ricerca FAQ</div>
    <div class="input-group col-md-8 col-12 text-right">
        <input
            type="text"
            #search
            class="form-control"
            placeholder="Cerca tra le faq"
        >
        <span class="input-group-append">
            <button
                class="btn btn-danger input-group-text"
                (click)="filterFaqs()"
            >
                <i class="fas fa-search"></i>
            </button>
        </span>
    </div>
</div>
<div class="modal-body">
    <faq
        [faqs]="filtered_faqs"
        [all_faqs]="faqs"
    ></faq>
</div>
